import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import { saveCurrentCoordinates } from '@redux/modules/listing';

import Button from '@components/smartAdminUI/Button';
import Card from '@components/smartAdminUI/Card';
import Modal from '@components/smartAdminUI/Modal';
import LocationPlotterMap from '@components/form/formComponents/inputGroups/locationPlotter/LocationPlotterMap';

const MapModal = () => {
  const dispatch = useDispatch();
  const [updatedCords, setUpdatedCords] = useState(null);

  const onUpdateLocationClicked = () => {
    if (updatedCords) {
      dispatch(saveCurrentCoordinates(updatedCords));
    }
  };

  const updateCoords = coords => {
    setUpdatedCords(coords);
  };

  return (
    <Modal
      id="locationPlotterModal"
      modalHeader="Location Plotter"
      position="center"
      size="lg"
    >
      <Card>
        <LocationPlotterMap
          onCoordsClicked={updateCoords}
        />
      </Card>
      <span data-toggle="modal" data-target="#locationPlotterModal">
        <Button
          name="btnLookupLocationUpdate"
          onClick={onUpdateLocationClicked}
          variant="primary"
        >
          <i className="fas fa-map-marker-alt mr-2" aria-hidden="true" />
          Update Location
        </Button>
      </span>
    </Modal>
  );
};

export default MapModal;
